import classNames from 'classnames'
import { useRouter } from 'next/router'
import { ICON_CHEVRON_LEFT_GRAY } from '../../../../modules/svg/svg'

// depth 1 (모아보기, overview 페이지) : NavBar 미노출
// depth 2~ (caf상세, 상상세, highlight) : NavBar 노출

/**
 * @param headerShown : 노출여부
 * @param handleClickBackBtn : 뒤로가기 버튼 클릭시 실행될 함수(history가 없는 경우 명시해줘야함) //
 */
interface INavBarProp {
  headerShown?: boolean
  handleClickBackBtn?: () => void
  title?: string
  capitalize: boolean
}

const NavBar = ({ headerShown = true, handleClickBackBtn, title, capitalize }: INavBarProp) => {
  const router = useRouter()
  /**
   * 상단 헤더 NavBar의 뒤로가기 버튼 클릭시 동작
   * 1. previous page history 있는 경우 : router.back()
   * 2. previous page history 없는 경우(처음 랜딩된경우) : Prop으로 커스텀하게 제어
   */
  const handleBack = () => {
    if (typeof handleClickBackBtn === 'function') {
      handleClickBackBtn()
      return
    }
    router.back()
  }
  // const navRef = useRef(null)
  // const navHeight = navRef?.current?.getBoundingClientRect()?.height
  return (
    <div className={styles.container(headerShown)}>
      {headerShown ? (
        <>
          <div className={styles.container2}>
            <div className="px-7" onClick={() => handleBack()}>
              <img className={styles.img} src={ICON_CHEVRON_LEFT_GRAY} alt="back_button" />
            </div>
            <div className={styles.titleCntr}>
              <h1 className={styles.title(capitalize)}>{title}</h1>
            </div>
          </div>
          <div className="border-b-1 border-gray-200" />
        </>
      ) : (
        <></>
      )}
    </div>
  )
}

const styles = {
  container: (headerShown: boolean) =>
    classNames(`fixed top-0 left-0 right-0 z-[998] bg-white`, headerShown && `h-[98px] pb-[13px]`),
  container2: `mt-[44px] flex h-[54px] flex-auto items-center justify-center bg-white px-[23px]`,
  img: `h-[14px] w-[14px] bg-white`,
  titleCntr: `col mr-[10px] items-center justify-center bg-white text-center`,
  title: (capitalize: boolean) =>
    classNames(`pr-[8px] text-[18px] font-medium tracking-wide`, capitalize && `capitalize`),
}
export default NavBar
